export default function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


//////////////////
// WEBPACK FOOTER
// ../~/css-vendor/~/@babel/runtime/helpers/esm/nonIterableSpread.js
// module id = 2581
// module chunks = 121